module.exports = __webpack_public_path__ + "img/banner.a386695e.png";